import React from "react";

import ProjectNavigator from "../projectNavigatorContainer";

class PreviousProjectNavigator extends React.Component {
  render() {
    return (
      <ProjectNavigator
        project={this.props.project}
        direction="previous"
        handleRouteLoad={this.props.handleRouteLoad}
      />
    );
  }
}
export default PreviousProjectNavigator;
